import uhaulStore from "../../CustomRedux/UhaulStore";
import { Manager } from "@twilio/flex-ui";
import { SyncClient } from "twilio-sync";
import ExceptionLogger from "../../ExceptionHelper";

export {
    getOriginalTaskAndOtherAgentInChat,
    getOtherAgentInChat,
    getLocalTkn,
    removeClosedData,
    toggleSupervisorTaskPanel,
    extractFriendlyName,
    capitalize,
    sendMessage,
    supervisorAvailable,
    initialResponseBody,
    containsInitialResponse
};

function getOriginalTaskAndOtherAgentInChat(props) {
    return new Promise(resolve => {
        var taskContext = uhaulStore.getState().UhaulReducer.currentTaskContext;
        if (taskContext == null) {
            resolve({ originalTask: null, otherAgentInChat: null });
            return;
        }

        var otherAgent = null;
        getOtherAgentInChat(props)
            .then((agent) => {
                otherAgent = agent;

                var task = null;

                if (taskContext._source && taskContext._source.attributes) {
                    task = { ...taskContext._source };
                }
                else if (taskContext._task) {
                    task = { ...otherAgent._task };
                }
                else if (taskContext.source && taskContext.source.attributes) {
                    task = { ...taskContext.source };
                }
                else {
                    task = { ...taskContext };
                }

                resolve({ originalTask: task, otherAgentInChat: otherAgent });
            });
    });
}

function getOtherAgentInChat(props) {
    return new Promise(resolve => {
        if (!(props.conversation && props.conversation.source)) {
            resolve(null);
            return;
        }

        var agent = null;

        props.conversation.source.getParticipants()
            .catch((err) => {
                resolve(null);
                return;
            })
            .then((participants) => {
                if (!participants) {
                    resolve(null);
                    return;
                }

                var currentUser = uhaulStore.getState().UhaulReducer.currentUser;

                // Convert map's entries or values to array
                var arr = Array.from(participants.values());

                const localSelfUserName = currentUser.workerName != null
                    ? currentUser.workerName.toLowerCase().replace(" ", "_5F")
                    : "";

                const environ =  uhaulStore.getState().UhaulReducer.config.environment;
                const targetWorkflowSid = environ === "PROD"
                        ? "WWfdc21e83b0472a13093040f3de80a4a8"
                        : "WWa72b723a57542c1d179fe320de5011b3";

                const allKeysExceptSelf = arr.filter(k =>
                    k != null &&
                    k.identity != null &&
                    k.identity.length < 15 &&
                    k.roleSid !== targetWorkflowSid &&
                    k.identity !== currentUser.friendlyName &&
                    k.identity !== localSelfUserName
                );

                if (allKeysExceptSelf == null) {
                    resolve(null); // no other agent
                    return;
                }

                var supervisor = arr.filter(k =>
                    k != null &&
                    k.identity != null &&
                    (k.identity === currentUser.friendlyName || k.identity === localSelfUserName)
                );

                if (allKeysExceptSelf.length > 1) {
                    // There is more than one other agent; use the newest.
                    let result = allKeysExceptSelf.map(a => a.lastConsumptionTimestamp);
                    var newestAgentDateAdded = new Date(Math.max.apply(null, result));
                    agent = allKeysExceptSelf.filter(x => x.lastConsumptionTimestamp === newestAgentDateAdded);
                }
                else if (allKeysExceptSelf.length <= 0) {
                    // If we are on local and monitoring our own task, then use our own name.
                    if (localSelfUserName.includes("5F")) {
                        agent = supervisor;
                    }
                }
                else {
                    // There is only one other agent.
                    agent = allKeysExceptSelf[0];
                }

                resolve(agent);
            });
    });
}

function getLocalTkn() {
    const key = "TWILIO_FLEX_SSO";
    var tkn = "";

    if (localStorage[key]) {
        var jsonParse = JSON.parse(localStorage[key]);
        if (jsonParse && jsonParse.token) {
            tkn = jsonParse.token;
        }
    }

    return tkn;
}

//6/3/20 : Removes records from the sync list that are not being monitored/barged.
function removeClosedData(accTkn) {
    var tkn = accTkn || getLocalTkn();

    if (tkn) {
        var syncClient = new SyncClient(tkn);
        var supervisorUser = uhaulStore.getState().UhaulReducer.currentUser;

        if (syncClient) {
            syncClient.list('BargedChats').then(function (list) {
                if (supervisorUser && list) {
                    list.getItems().then(function (page) {
                        if (page && page.items && page.items.length > 0) {
                            for (var i = 0; i < page.items.length; i++) {
                                var x = page.items[i];
                                if (x.value && x.value.user === supervisorUser.sid) {
                                    list.remove(x.index).then(function () {
                                    });
                                }
                            }
                        }
                    });
                }
            });
        }
    }
}

function toggleSupervisorTaskPanel(styleIndicator){
    var supervisorTaskCanvas = document.getElementsByClassName("Twilio-TaskCanvas");
    if(supervisorTaskCanvas && supervisorTaskCanvas.length > 0)
    {
        for(var i = 0; i < supervisorTaskCanvas.length; i++)
        {
            supervisorTaskCanvas[i].style = styleIndicator;
        }
    }
}

function extractFriendlyName(workerDefaultName) {
    var friendlyName = "You";
    if (workerDefaultName !== null) {
      if (workerDefaultName.includes("_")) {
        var splitNames = workerDefaultName.split("_");
        if (splitNames !== null && splitNames.length > 0) {
          friendlyName = capitalize(splitNames[0]);
        }
      }
      else if (workerDefaultName.includes(" ")) {
        var spacedNames = workerDefaultName.split(" ");
        if (spacedNames !== null && spacedNames.length > 0) {
          friendlyName = capitalize(spacedNames[0]);
        }
      }
    }
    if (friendlyName === null || friendlyName.trim() === "") {
      friendlyName = "You";
    }
    return friendlyName;
}

function capitalize(word) {
  return (word != null && word.trim() !== "")
  ? word.charAt(0).toUpperCase() + word.slice(1)
  : word;
}

function sendMessage(sid, author, body) {
    var serviceBaseUrl = uhaulStore.getState().UhaulReducer.currentUser.serviceBaseUrl;
    fetch(serviceBaseUrl + "send-message",
    {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        method: "POST",
        body: new URLSearchParams({
            Token: Manager.getInstance().user.token,
            channelSid: sid,
            author: author,
            body: body
        })
    });
}

function supervisorAvailable() {
    return new Promise(resolve => {
        var serviceBaseUrl = uhaulStore.getState().UhaulReducer.currentUser.serviceBaseUrl;

        const manager = Manager.getInstance();

        /*Local usage of the fetch-retry mechanism */
        const originalFetch = require('isomorphic-fetch');
        const fetch = require('fetch-retry')(originalFetch);

        fetch(serviceBaseUrl + "are-supervisors-available", {
            method: "POST",
            body: new URLSearchParams({
                Token: manager.user.token,
                workerSid: manager.workerClient?.sid
            }),
            retryDelay: function(attempt, error, resp) {
                return Math.pow(2, attempt) * 500; //half second
            },
            retryOn: function(attempt, error, resp) {
                if (attempt > 3) {
                    ExceptionLogger(error, "SupervisorAvailable", "Attempted 3 times already", "",`${resp}`);
                    return false;
                }
                if (error !== null || resp.status == 429) {
                    ExceptionLogger(error, "SupervisorAvailable", "retrying, attempt number ${attempt + 1}", "",`${resp}`);
                    return true;
                }
            }
        })
        .then(response => {
            if(response && response.ok)
            {
                return response.json();
            }
            else{
                throw new Error(`Response Error}`);
            }
        })
        .then(data => {
            resolve(data.areSupervisorsAvailable);
        })        
        .catch((err) => {
            console.log("FETCH ERROR: ", err);
            ExceptionLogger(err, "SupervisorAvailable", "Error with SupervisorAvailable", "", "");
            
        });
    });
}

/**
 * Generates an initial response message for a customer chat session.
 * Attempts to personalize the greeting by extracting the customer's first name from task attributes.
 * 
 * @param {Object} task 
 * @param {Object} [task.attributes] - Task attributes containing customer data
 * @param {string} [task.attributes.friendlyName] - Eg "John Doe"
 * @returns {string} A personalized greeting message for the customer
 */
const initialResponseBody = (task) => {
    // Try to get customer first name from task attributes
    const customerName = task.attributes?.friendlyName?.trim()?.split(' ')[0] || "";

    return customerName 
        ? `Hi ${customerName}! Thank you for chatting in today, it's my pleasure to assist you. Please allow me one moment while I look into your request. Thank you for your patience.`
        : "Hi! Thank you for chatting in today, it's my pleasure to assist you. Please allow me one moment while I look into your request. Thank you for your patience.";
}

/**
 * Checks if a string already contains an initial response message.
 * @param {string} str
 */
const containsInitialResponse = (str) => str.includes("Thank you for chatting in today")